export type DeviceType = "mobile" | "tablet" | "desktop";

export interface DeviceInfo {
    type: DeviceType;
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    userAgent: string;
}

export const defaultDevice: DeviceInfo = {
    type: "desktop",
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    userAgent: "",
} as const;
